import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DistrictService } from '../../_services/_masters/district.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
declare var $ : any;
class DistrictForm {
	district_name:string;
}
@Component({
  selector: 'app-district',
  templateUrl: './district.component.html',
  styleUrls: ['./district.component.css']
})
export class DistrictComponent implements OnInit {

  	districtForm : FormGroup;
	modalDistrictForm : FormGroup;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	district_form: DistrictForm[] = [];

	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_district : string = null ;
	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;
	
	constructor( private districtService : DistrictService, private http: Http) { }

	ngOnInit() {

		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.token = this.currentUser.token;
		this.user_role = this.currentUser.role;
		this.user_district = this.currentUser.district;

		this.districtForm = new FormGroup({
			'district_name': new FormControl(null , Validators.required),
		});
		
		this.modalDistrictForm = new FormGroup({
			'district_name': new FormControl(null , Validators.required),
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

	this.http.get(this.url + '/masters/district/all')
	// this.http.get('http://backendtransport.iogreen.in/masters/district/all')
		.map(this.extractData)
		.subscribe(forms => {
			this.district_form = forms;
			console.log(this.district_form);
			// Calling the DT trigger to manually render the table
			this.dtTrigger.next();
		});
	}
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.districtService.getDistrictFormWith(info[0])
		.subscribe(response => {
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalDistrictForm.patchValue({
				"district_name": this.modalData[0].district_name
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		this.districtService.addNewDistrict(this.districtForm.value)
		.subscribe(response => 
		{			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.
				then((dtInstance: DataTables.Api) => 
				{
					dtInstance.destroy();
					this.http.get(this.url + '/masters/district/all')
						.map(this.extractData)
						.subscribe(forms => 
						{
							this.district_form = forms;
							console.log(this.district_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateDistrict(){
		console.log(this.modalDistrictForm.value);
		console.log(this.modalData);

		this.query={
			"district_oid" : this.modalData[0]._id,
			"district_data" : this.modalDistrictForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/district/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'District Updated Successfully'){
					swal(
						'Success',
						'District Form Updated Successfully',
						'success'
					);
				}

				if (this.response.message === 'District Information not Changed'){
					swal(
						'Info',
						'District information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/district/district.component.ts